module.exports = __webpack_public_path__ + "img/reisen udongein inaba eternal_sc1.090343dd.png";